__turbopack_context__.v({
  "graph": "k3VgPW_graph",
});
